// extracted by mini-css-extract-plugin
export default {"link":"social-section-core-FeedSectionPhotoCarousel__link--1_5mU","carouselBottom":"social-section-core-FeedSectionPhotoCarousel__carouselBottom--2mFIc"};